import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import {ObjectTypes} from '../../../../api/consts';
import BaseSSLInspection from '../../AbstractObjects/GatewayPlan/InnerPages/BaseSSLInspection';

const pageSchema = GatewayGetSchema.pages.sslInspection;
const pageId = pageSchema.pageId;

function PlanSSLInspection({
                               planObject,
                               setPlanData,
                               setAppiDataValue,
                           }) {
    const pageData = planObject[pageId];
    const planName = planObject[GatewayGetSchema.id];

    return (
        <BaseSSLInspection
            pageData={pageData}
            setObjectData={setPlanData}
            baseObjectName={planName}
            objectType={ObjectTypes.PLAN}
            setAppiDataValue={setAppiDataValue}
        />
    );
}

export default PlanSSLInspection;